<template>
<div class="index page_parkmall page_map page_item">
	<!-- 搜索区域 -->
	<div class="index_top top_nobg">
		<van-row type="flex" justify="space-start">
			<van-col v-if="searchlefticon" class="left_col">
				<van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" />
			</van-col>
			<van-col :class="searchlefticon ? 'search_col': searchrighticon ? 'search_col_big': 'search_col_big_rise'">
				<van-cell-group class="search_field">
					<van-field v-model="search_value" :placeholder="placeholder">
					</van-field>
					<div class="icontext" @click="search">搜索</div>
				</van-cell-group>
			</van-col>
			<van-col v-if="searchrighticon != ''" class="right_col" @click="clicksearchright">
				<van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .5rem;" />
			</van-col>
		</van-row>
	</div>
    <!-- 园区 列表 -->
	<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
		<div class="content">
			<ul class="list">
				<li class="item clearfix" v-for="park in dataList" :key="park.id"  @click="toDetail(park)">
					<div class="thumb f-l">
						<van-image fit="cover" :show-loading="false" :src="park.thumb ? imageUrl+park.thumb : $publicData.intangibleDefault" :error-icon="$publicData.intangibleDefault" />
					</div>
					<div class="info f-l">
						<div class="info_t">
							<div class="title clearfix">
								<span class="tag" v-if="park.level">{{ park.level }}</span>
								<span class="txt" v-if="park.name">{{ park.name }}</span>
							</div>
							<div class="desc slh_three" v-if="park.describe">{{ park.describe }}</div>
						</div>
						<div class="weizhi" v-if="park.province || park.city || park.area">
							<div class="text">{{ ''+ park.province.areaname + park.city.areaname + park.area.areaname + park.address }}</div>
						</div>
					</div>
				</li>
				<!-- <li class="item clearfix">
					<div class="thumb f-l">
						<van-image fit="cover" :show-loading="false" :src="$publicData.intangibleDefault" :error-icon="$publicData.intangibleDefault" />
					</div>
					<div class="info f-l">
						<div class="title clearfix">
							<span class="tag">国家级</span>
							<span class="txt">河北衡水湖国家级自然保护区</span>
						</div>
						<div class="desc slh_three">乌金山镇小西沟新村是中国西北的村落，旧村位于乌金山镇西北紧邻省城太原，新村总面积200余亩，耕地面积</div>
						<div class="weizhi">
							<div class="text">山西省晋中市榆次区乌金山镇下辖的行政村</div>
						</div>
					</div>
				</li> -->
			</ul>
		</div>
	</van-list>
    <!-- 遮罩层 -->
    <!-- <van-overlay :show="search_status" class="overlay" /> -->
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "map-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage, 
            publicPath: process.env.BASE_URL,
            token: null,
            finished: false,
            page: 1,
            size: 10,
            loading: true,
            refreshing: false,
			shareConfig: null, // 分享的相关配置
			dataList: [],
			searchlefticon: '', // 搜索栏左侧图标
			searchrighticon: '', // 搜索栏右侧图标
			search_value: '', // 搜索值
			placeholder: '请输入要搜索的园区',
			righticon: process.env.BASE_URL + '/statics/images/search_gery_icon.png', // 搜索框搜索图标
        };
    },
    components: {
        PageSearch
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '园区商城'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
                this.getData();
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
			this.token = this.$store.getters.token
			// 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
            // this.getShareData()
            this.getData();
        }
        // console.log(this.$refs.marker)
    },
    methods: {
        search() {
			var that = this
			that.page = 1
			that.dataList = []
			that.getData()
        },
        
        // 获取列表
        getData() {
            var params = {
                token: this.token,
                page: this.page,
                size: this.size
			}
			if(this.search_value){
				params.name = this.search_value
			}
            console.log('params', params)
            this.$api.parkmall.list(params).then(res => {
                if (res.code == 200) {
					var list = res.result;
					if(list.length != 0){
						this.dataList = this.dataList.concat(list)
						this.page++;
						this.loading = false;
					}else{
						// 数据全部加载完
                        this.finished = true
                        return;
					}
                } else {
                    this.finished = true
                    this.$toast(res.message)
                }
                
            })
		},
		// 详情
        toDetail(park) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/parkmall/index?park_uuid=' + park.park_uuid
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/parkmall/index',
                    query: {
                        park_uuid: park.park_uuid
                    }
                })
            }
        },
		// 点击右侧图标
		clicksearchright(){

		},
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '园区商城', // 分享标题
                    desc: '时代记忆', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.domain + that.$publicData.logo, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	.page_iteminfo .con_jiangren{
		margin-top: 0;
	}
</style>
